// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2TTph","title":"Images90_title__2imoM","images":"Images90_images__LIwz5"};